import { useNavigate } from "react-router-dom";
import {
  PageContainer,
  PageHeader,
} from "@volca/ui/components/ui/page-components";
import { NewReportControls } from "@/profitability/new-report-controls";
import { ReportPresentationProvider } from "@/profitability/report-presentation";
import { profitabilityRunPath } from "@/profitability/routes";
import { RunList } from "@/profitability/run-list";

export const ServiceTitanContent = ({ businessId }: { businessId: string }) => {
  const navigate = useNavigate();
  const openRun = (id: string) => navigate(profitabilityRunPath(id));
  return (
    <ReportPresentationProvider value="classic">
      <PageContainer variant="workspace">
        <PageHeader
          title="Job Costing"
          actions={
            <NewReportControls businessId={businessId} onCreated={openRun} />
          }
        />
        <RunList
          workflowVersion={1}
          businessId={businessId}
          onOpenRun={openRun}
        />
      </PageContainer>
    </ReportPresentationProvider>
  );
};
